import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user_info",
  "use": "icon-user_info-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user_info\"><path d=\"M343.04 539.741091a295.610182 295.610182 0 1 1 166.818909 51.525818c-239.755636 0-432.733091 175.429818-432.733091 389.864727a38.539636 38.539636 0 0 1-77.125818 0c0-204.986182 143.732364-378.228364 343.04-441.390545z m166.818909-25.6a218.530909 218.530909 0 1 0 0-437.061818 218.530909 218.530909 0 0 0 0 437.061818z m85.690182 209.92h385.582545a42.821818 42.821818 0 1 1 0 85.690182h-385.582545a42.821818 42.821818 0 1 1 0-85.643637z m0 214.248727h385.582545a42.821818 42.821818 0 1 1 0 85.690182h-385.582545a42.821818 42.821818 0 1 1 0-85.690182z\" p-id=\"1165\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user_info.svg
// module id = XYXb
// module chunks = 197